import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * The single page-content layer for every operator screen. Gives ONE consistent
 * padding scale (responsive) + the standard title/description/actions header, so
 * spacing is identical across all apps instead of each page hand-rolling its own
 * `p-8`/`p-6`. Pair with `Table` for data screens. Change the padding here → it
 * changes platform-wide.
 *
 *   <Page title="Global Entities" description="…" actions={<Button>Create</Button>}>
 *     <Table … />
 *   </Page>
 */
export function Page({ title, description, actions, narrow = false, className = "", children, }) {
    const hasHeader = title != null || description != null || actions != null;
    return (_jsx("div", { className: `p-4 sm:p-6 lg:p-8 ${className}`.trim(), children: _jsxs("div", { className: narrow ? "mx-auto w-full max-w-3xl" : "w-full", children: [hasHeader && (_jsxs("div", { className: "mb-6 flex flex-wrap items-start justify-between gap-3", children: [_jsxs("div", { className: "min-w-0", children: [title != null && (_jsx("h1", { className: "text-2xl font-bold text-content", children: title })), description != null && _jsx("p", { className: "mt-1 text-sm text-muted", children: description })] }), actions != null && _jsx("div", { className: "flex flex-shrink-0 items-center gap-2", children: actions })] })), children] }) }));
}
//# sourceMappingURL=Page.js.map